import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { SiteAlertsInterface } from 'types';

/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
import clientApi from '../api/client.api';

export const siteAlertsApi = createApi({
  reducerPath: 'siteAlerts',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  endpoints: (builder) => ({
    getSiteAlerts: builder.query<SiteAlertsInterface[], string>({
      queryFn: async () => {
        try {
          const { data } = await clientApi.getSiteAlerts();

          return { data };
        } catch (error) {
          console.error(`Error while get past forms: ${error.message}`);

          return { error };
        }
      }
    })
  })
});

export const { useGetSiteAlertsQuery } = siteAlertsApi;
